import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from './LoadingSpinner';
import EmptyState from './EmptyState';

/**
 * What a detail page shows instead of a record that is not the one in the URL
 * (see helpers/detailRequest): a spinner while it loads; if it failed, the
 * server's reason and a retry.
 */
const DetailRecordFallback = ({ waiting, title, error, onRetry }) => {
  if (waiting) return <LoadingSpinner size="md" className="!tw-py-8" />;

  return (
    <EmptyState
      title={title}
      description={error || 'It may have been deleted, or you may not have access to it.'}
      action={onRetry}
      actionLabel="Retry"
    />
  );
};

DetailRecordFallback.propTypes = {
  waiting: PropTypes.bool.isRequired,
  title: PropTypes.string,
  error: PropTypes.string,
  onRetry: PropTypes.func,
};

DetailRecordFallback.defaultProps = {
  title: 'Record not available',
  error: null,
  onRetry: undefined,
};

export default DetailRecordFallback;
